import { createHandler } from '@mews/std';
import { DesignToken, getToken } from '@optimus-web/core';
import { HighlightIconVariant } from './types';

const getBackgroundColorToken = createHandler<HighlightIconVariant, DesignToken>({
    basic: 'backgroundAlertBasicSecondary',
    primary: 'legacyTagBackgroundPrimary',
    info: 'backgroundAlertInfoSecondary',
});

export const getBackgroundColor = (variant: HighlightIconVariant) => getToken(getBackgroundColorToken(variant));

const getIconColorToken = createHandler<HighlightIconVariant, DesignToken>({
    basic: 'textAlertBasic',
    primary: 'legacyTagTextPrimary',
    info: 'textAlertInfo',
});

export const getIconColor = (variant: HighlightIconVariant) => getToken(getIconColorToken(variant));
